<template>
  <BootstrapModal
    ref="modal"
    modalId="deleteModal"
    title="Confirm Deletion"
    closeText="No"
    confirmText="Yes, Delete"
    isDeleteConfirmation
    :deleteMessage="deleteMessage"
    @confirm="handleConfirm"
  />
</template>
  
<script>
import BootstrapModal from "@/components/Common/BootstrapModal.vue";
import deviceService from "@/services/deviceService";
import emitter from "@/eventBus";

export default {
  name: "DeleteDeviceModal",
  components: { BootstrapModal },
  props: {
    device: {
      type: Object,
      required: false,
      default: null,
    },
  },
  emits: ["deleted"],
  computed: {
    deleteMessage() {
      return this.device
        ? `Are you sure you want to delete device <b>"${this.device.name}"</b>?<br> 
            <span class="text-secondary small">This action is irreversible and cannot be undone. Please proceed with caution.</span>`
        : "Are you sure you want to delete this device? This action is irreversible.";
    },
  },
  methods: {
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    async handleConfirm() {
      if (!this.device?.id) return;

      try {
        await deviceService.deleteDevice(this.device.id);
        emitter.emit("show-toast", {
          message: `Device "${this.device.name}" deleted successfully.`,
          type: "success",
        });
        this.$emit("deleted", this.device.id);
      } catch (error) {
        console.error(error);
      }

      this.hide();
    },
  },
};
</script>
  